export enum ImageSize {
  Original = '',
  Inline = '16x16',
  Icon = '32x32',
  Thumb = '50x50',
  SmallLogo = '100x100',
  Logo = '160x160',
  ProductThumb = '240x240',
  ProductImage = '480x480',
  BannerImage = '600x600',
  WallPaper1024 = '1024x1024',
  WallPaper2048 = '2048x2048',
}
